export default function getHrefWithHostname(href) {
  return `https://${window.location.hostname}${href}`;
}
